<template>
    <div class="wrapper">
        <nav id="sidebar" class="sidebar">
            <a class="sidebar-brand" href="/">
                GES Tracker - ALIBORA
            </a>
            <div class="sidebar-content">
                <div class="sidebar-user">
                    <img src="/img/avatars/avatar.jpg" class="img-fluid rounded-circle mb-2" alt="Linda Miller" />
                    <div class="fw-bold">{{ user?.name ?? "-" }}</div>
                    <small>{{ user?.email ?? "-" }}</small>
                </div>

                <ul class="sidebar-nav">
                    <li class="sidebar-header">
                        Mes Groupes
                    </li>
                    <Groupes />
                </ul>
            </div>
        </nav>
        <div class="main">
            <nav class="navbar navbar-expand navbar-theme">
                <a class="sidebar-toggle d-flex me-2" @click="toggleSidebar">
                    <i class="hamburger align-self-center"></i>
                </a>
                <div class="navbar-collapse collapse">
                    <ul class="navbar-nav ms-auto" v-if="user.is_admin == 1">

                        <li class="nav-item dropdown ms-lg-2">
                            <a class="nav-link dropdown-toggle position-relative" href="#" id="userDropdown"
                                data-bs-toggle="dropdown">
                                <i class="align-middle fas fa-cog"></i>
                            </a>
                            <div class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">

                                <a class="dropdown-item" href="#" @click="goToAdmin">
                                    <i class="align-middle me-1 fas fa-fw fa-cog"></i>Administration
                                </a>
                                <div class="dropdown-divider"></div>

                                <a class="dropdown-item" @click="logoutUser">
                                    <i class="align-middle me-1 fas fa-fw fa-arrow-alt-circle-right"></i>
                                    Déconnexion
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>



            <main class="content">
                <div class="container-fluid">

                    <header-view />

                    <!-- <template v-if="!isLoading"> -->
                    <!-- <content-view /> -->
                    <content-test-view />
                    <!-- </template> -->
                    <MessageContent />

                </div>
            </main>

            <footer class="footer">
                <div class="container-fluid">
                    <div class="row text-muted">
                        <div class="col-8 text-start">
                            <ul class="list-inline">
                                <li class="list-inline-item">
                                    <a class="text-muted" href="#"></a>
                                </li>
                                <li class="list-inline-item">
                                    <a class="text-muted" href="#"></a>
                                </li>
                                <li class="list-inline-item">
                                    <a class="text-muted" href="#"></a>
                                </li>
                                <li class="list-inline-item">
                                    <a class="text-muted" href="#"></a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-4 text-end">
                            <p class="mb-0">
                                &copy; 2024 - <a href="#" class="text-muted">ALIBORA</a>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </div>

    <svg width="0" height="0" style="position:absolute">
        <defs>
            <symbol viewBox="0 0 512 512" id="ion-ios-pulse-strong">
                <path
                    d="M448 273.001c-21.27 0-39.296 13.999-45.596 32.999h-38.857l-28.361-85.417a15.999 15.999 0 0 0-15.183-10.956c-.112 0-.224 0-.335.004a15.997 15.997 0 0 0-15.049 11.588l-44.484 155.262-52.353-314.108C206.535 54.893 200.333 48 192 48s-13.693 5.776-15.525 13.135L115.496 306H16v31.999h112c7.348 0 13.75-5.003 15.525-12.134l45.368-182.177 51.324 307.94c1.229 7.377 7.397 11.92 14.864 12.344.308.018.614.028.919.028 7.097 0 13.406-3.701 15.381-10.594l49.744-173.617 15.689 47.252A16.001 16.001 0 0 0 352 337.999h51.108C409.973 355.999 427.477 369 448 369c26.511 0 48-22.492 48-49 0-26.509-21.489-46.999-48-46.999z">
                </path>
            </symbol>
        </defs>
    </svg>
</template>


<script>

// import HelloWorld from '../../components/HelloWorld.vue'
// import MultiSelect from 'primevue/multiselect';
// import Dropdown from 'primevue/dropdown';
import Groupes from "../../components/devices/Groupes.vue"
import HeaderView from "../../components/HeaderView.vue"
// import ContentView from "../../components/ContentView.vue"
import ContentTestView from "../../components/ContentTestView.vue"
import { mapFields } from 'vuex-map-fields'
import MessageContent from "@/components/MessageContent.vue"
import { mapActions } from 'vuex'

import store from '@/store';

// const url = process.env.VUE_APP_API_TRACKER_BASE_URL


export default {
    name: "HomePage",
    components: {
        Groupes,
        HeaderView,
        // MultiSelect,
        // Dropdown,
        ContentTestView,
        MessageContent,
    },
    data() {
        return {
            showModal: false,
            user: {
                email: '_',
                name: "_",
            }
        }
    },
    mounted() {
        // this.user = JSON.parse(localStorage.getItem("user"))
        this.getAllGroups();
        this.checkAuth();
        this.checkAuth().then(() => {
            this.user = JSON.parse(localStorage.getItem("user"))
        }).catch((err) => {
            this.user = JSON.parse(localStorage.getItem("user"))
        })
    },

    computed: {
        ...mapFields('devices/list', {
            deviceItem: 'items',
            isLoading: 'isLoading',
            groupes: "groupes",
        }),
    },

    methods: {
        ...mapActions({
            logout: 'auth/logout',
            getAllGroups: "devices/list/getAllGroups",
            checkAuth: 'auth/checkToken'
        }),

        logoutUser() {
            this.logout().then(() => {
                this.$router.replace({ name: 'Login' })
            }).catch(() => {
                this.$router.replace({ name: 'Login' })
            })
        },

        goToAdmin() {
            this.$router.push({ name: 'AdminDashboard' })
        },

        toggleSidebar() {
            const sidebar = document.getElementById('sidebar');
            const isOpen = sidebar.classList.contains('toggled');
            if (isOpen) {
                sidebar.classList.remove('toggled');
            } else {
                sidebar.classList.toggle('toggled')
            }
        }
    }

}
</script>

<style></style>